import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../../core/services/api.service';
import { AppConfig } from '../../core/services/app-config.service';
import { CustomerStoreService } from '../../core/services/customer-store.service';
import { Store } from '../../core/services/store.service';
import { DobryPradFormData } from '../models/dobry-prad-form-data';
import { IDashboardOffers, IOffer, XsellOffer } from '../models/model';

@Injectable({
  providedIn: 'root',
})
export class OffersStoreService extends Store<IOffersState> {
  constructor(
    private api: ApiService,
    private customerStoreService: CustomerStoreService,
    private appConfig: AppConfig,
  ) {
    super({
      all: { loading: false },
      dashboard: { loading: false },
    });
  }

  public loadDashboardOffers(): Observable<IDashboardOffers> {
    this.setState({ ...this.state, dashboard: { ...this.state.dashboard, loading: true } });
    return this.api.get<IDashboardOffers>('/offers/dashboard', null, true).pipe(
      tap((dashboardOffers: IDashboardOffers) => {
        this.setState({ ...this.state, dashboard: { loading: false, dashboardOffers } });
      }),
    );
  }

  public getOffer(offerId: string): Observable<IOffer> {
    return this.api.get<IOffer>(`/offers/${offerId}`);
  }

  public getXsellOffer(offerId: string): Observable<XsellOffer> {
    return this.api.get<XsellOffer>(`/offers/xsell/${offerId}`);
  }

  public saveXsellOffer(offerId, payload): Observable<XsellOffer> {
    return this.api.post(`/offers/xsell/${offerId}/contact`, payload);
  }

  public prepareDobryPradOffer(payload: DobryPradFormData): Observable<any> {
    return this.api.post(`/customers/${this.customerStoreService.state.customerId}/dobry-prad/contact-form`, payload);
  }
}

interface IOffersState {
  all: {
    loading: boolean;
    offers?: IOffer[];
  };
  dashboard: {
    loading: boolean;
    dashboardOffers?: IDashboardOffers;
  };
}
